const { getElements } = window.BAO.Utils

class WishlistModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.addToWishlist = this.addToWishlist.bind(this)

    this.checkLoggedIn = this.checkLoggedIn.bind(this)
    this.checkIsInWishlist = this.checkIsInWishlist.bind(this)

    this.activateTriggers = this.activateTriggers.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.WISHLIST.WISHLIST_ADDED,
      this.activateTriggers,
    )
    this.populateLists = this.populateLists.bind(this)

    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      this.activateTriggers()
    })
  }

  activateTriggers () {
    this.checkLoggedIn()

    this.checkIsInWishlist()

    this.externalEls.trigger?.elements.forEach((el) => {
      el.setAttribute('data-wishlist-active', '')
    })
  }

  checkLoggedIn () {
    if (this.hasAttribute('data-is-customer')) return

    /* eslint-disable no-console */
    window._swat.disconnectShopperContext(
      (onSuccess) => console.log('User cleared'),
      this.wishlistError,
    )
    /* eslint-enable */
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)

    this.checkIsInWishlist()
  }

  async handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-modal-external-el="trigger"], [data-wishlist-modal-external-el="saveForLater"]',
    )

    if (!trigger || !window._swat) return

    if (trigger.hasAttribute('data-wishlist-added')) {
      const lid = trigger.dataset.wishlistId

      const product = {
        epi: trigger.dataset.variantId,
        empi: trigger.dataset.productId,
        du: trigger.dataset.productUrl,
      }

      window._swat.deleteFromList(
        lid,
        product,
        this.checkIsInWishlist,
        this.wishlistError,
      )
    } else {
      await window.BAO.sectionRenderer
        .fetchSingle('wishlist-modal-product', trigger.dataset.productUrl)
        .then((res) => {
          const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
          const myself = newDOM.querySelector('.shopify-section')

          this.els.product.element.innerHTML = myself.innerHTML

          this.setAttribute('aria-hidden', false)
          document.body.classList.toggle('util-SiteOverflowed', true)
        })
        .catch(() => {
          this.setAttribute('aria-hidden', true)
          document.body.classList.toggle('util-SiteOverflowed', false)
        })

      this.els.submit.element.setAttribute(
        'data-product-id',
        trigger.dataset.productId,
      )
      this.els.submit.element.setAttribute(
        'data-variant-id',
        trigger.dataset.variantId,
      )
      this.els.submit.element.setAttribute(
        'data-product-url',
        trigger.dataset.productUrl,
      )

      window._swat.fetchLists({
        callbackFn: (lists) => this.populateLists(lists, trigger),
        errorFn: this.wishlistError,
      })
    }
  }

  populateLists (lists, trigger) {
    this.els.lists.element.innerHTML = ''

    lists.forEach((list, index) => {
      this.els.lists.element.innerHTML += `<div class="frm-Form_Field frm-Form_Field-checkbox">
        <input class="frm-Form_Checkbox" type="radio" id="list${
          list.lid
        }" name="wishlist_list" value="${list.lid}"${
          index === 0 ? ' checked' : ''
        }>
        <label class="frm-Form_Label" for="list${list.lid}">${list.lname} (${
          list.cnt
        })</label>
        </div>`
    })

    if (lists.length === 0) {
      this.els['newlist-checkbox'].element.setAttribute('checked', '')
      this.els.newlist.element.value = 'My wishlist'
    } else {
      this.els['newlist-checkbox'].element.removeAttribute('checked')
      this.els.newlist.element.value = ''
    }

    if (trigger.dataset.wishlistModalExternalEl === 'saveForLater') {
      const saveForLaterList = lists.find(
        (list) => list.lname === 'Save for Later',
      )
      if (saveForLaterList) {
        this.addToSaveForLater(saveForLaterList.lid)
      } else {
        const listConfig = {
          lname: 'Save for Later',
        }

        window._swat.createList(
          listConfig,
          (newList) => {
            this.populateLists([...lists, newList], trigger)
            window._swat.fetchLists({
              callbackFn: (updatedLists) => {
                const saveForLaterList = updatedLists.find(
                  (list) => list.lname === 'Save for Later',
                )
                if (saveForLaterList) {
                  this.addToSaveForLater(saveForLaterList.lid)
                }
              },
              errorFn: this.wishlistError,
            })
          },
          this.wishlistError,
        )
      }
    }
  }

  addToSaveForLater (lid) {
    window._swat.fetchLists({
      callbackFn: (lists) => {
        const saveForLaterList = lists.find((list) => list.lid === lid)
        const isProductInList = saveForLaterList.listcontents.some(
          (product) =>
            product.empi ===
            parseInt(this.els.submit.element.dataset.productId),
        )

        // Check if product is already in this list, else add it.
        if (!isProductInList) {
          const product = {
            epi: parseInt(this.els.submit.element.dataset.variantId),
            empi: parseInt(this.els.submit.element.dataset.productId),
            du: this.els.submit.element.dataset.productUrl,
          }

          window._swat.addToList(
            lid,
            product,
            () => {
              this.handleClose()
              window.location.href = '/pages/wishlist'
            },
            this.wishlistError,
          )
        }
      },
      errorFn: this.wishlistError,
    })
  }

  handleSubmit () {
    const listChoice = getElements('[name="wishlist_list"]').find(
      (el) => el.checked,
    )

    if (listChoice.value === 'new') {
      const listConfig = {
        lname: this.els.newlist.element.value,
      }

      window._swat.createList(
        listConfig,
        (newList) => this.addToWishlist(newList.lid),
        this.wishlistError,
      )
    } else {
      this.addToWishlist(listChoice.value)
    }
  }

  addToWishlist (lid) {
    const product = {
      epi: parseInt(this.els.submit.element.dataset.variantId),
      empi: parseInt(this.els.submit.element.dataset.productId),
      du: this.els.submit.element.dataset.productUrl,
    }

    window._swat.addToList(lid, product, this.handleClose, this.wishlistError)
  }

  checkIsInWishlist () {
    window._swat.fetchLists({
      callbackFn: (lists) => {
        const productCount = lists.reduce(
          (accumulator, list) => accumulator + list.cnt,
          0,
        )
        this.externalEls.count.element.setAttribute(
          'aria-hidden',
          productCount === 0,
        )

        this.externalEls.trigger?.elements.forEach((el) => {
          const matchedProduct = lists.find((list) =>
            list.listcontents.find(
              (product) => product.empi === parseInt(el.dataset.productId),
            ),
          )

          if (matchedProduct) {
            el.setAttribute('data-wishlist-added', '')
            el.setAttribute('data-wishlist-id', matchedProduct.lid)
          } else {
            el.removeAttribute('data-wishlist-added')
            el.removeAttribute('data-wishlist-id')
          }
        })
      },
      errorFn: this.wishlistError,
    })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.error(`Wishlist error: ${errorMessage}`);
  }
}

if (!customElements.get('wishlist-modal')) {
  customElements.define('wishlist-modal', WishlistModal)
}
